import { render, staticRenderFns } from "./CuentaAliadaCreateUpdate.vue?vue&type=template&id=7a30c83e"
import script from "./CuentaAliadaCreateUpdate.vue?vue&type=script&lang=js"
export * from "./CuentaAliadaCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports